export const CONTACTS_SERVICE_KEY = 'contacts-api';
export const REQUEST_PAYLOAD_MAX_BYTES = 4000000;
export const MAX_PARALLEL_BATCH_PROCESSING = 4;
export const FAILED_REQUEST_REPEATS = 3;
export const CONTACTS_DELETE_MAX_AMOUNT = 1000;
export const BULK_POLING_PAUSE_DURATION = 1500;
export const BULK_FAILED_SERIES_REPEAT_IN = 30000;
export const DB_TARGET_VERSION_HEADER = 'x-db-target-version';
export const DB_ORIGIN_VERSION_HEADER = 'x-db-origin-version';
//# sourceMappingURL=constants.js.map